export interface OfficeToHomeBuffer {
  earliestHomeMinutes: number | null;
  message: string | null;
  latestOfficeMinutes: number | null;
  officeMessage: string | null;
}

interface SlotWithBuffer {
  time: string;
  devaLocation: string;
  officeToHomeBuffer: OfficeToHomeBuffer | null;
}

export function officeToHomeConflictMessage(slot: SlotWithBuffer): string | null {
  const buffer = slot.officeToHomeBuffer;
  if (!buffer) return null;
  const [hour, minute] = slot.time.split(":").map(Number);
  const minutes = hour * 60 + minute;
  if (slot.devaLocation === "home" && buffer.earliestHomeMinutes != null && minutes < buffer.earliestHomeMinutes) {
    return buffer.message;
  }
  if (slot.devaLocation === "office" && buffer.latestOfficeMinutes != null && minutes > buffer.latestOfficeMinutes) {
    return buffer.officeMessage;
  }
  return null;
}

export default function OfficeToHomeWarning({ slots }: { slots: SlotWithBuffer[] }) {
  const messages = new Set(slots.map(officeToHomeConflictMessage).filter((message): message is string => Boolean(message)));

  if (messages.size === 0) return null;

  return (
    <div className="app-alert-warning mt-3" role="alert">
      <p className="font-semibold">Selected times need an office-to-home travel buffer.</p>
      {Array.from(messages).map((message) => <p key={message}>{message}</p>)}
    </div>
  );
}
